// @ts-nocheck
import * as React from "react";
import anime from "animejs/lib/anime.es.js";


// Components
import Loader from "../Loader";
import Banner from "../Banner";

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

const elementList = [
    <img className='af-bg-aditional__cloud' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube1.png`} alt="" title="" />,
    <img className='af-bg-aditional__cloud2' src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube3.png`} alt="" title="" />,
]

export const Contact = ({ title, desc, setLoading, loading }: any) => {
    const [openModal, setOpenModal] = React.useState(false)

    React.useEffect(() => {
        const urlFlagSend = new URL(location.href)?.searchParams?.get("send");
        urlFlagSend && setOpenModal(true)
    }, [openModal]);

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
        }
    }, []);

    const animateSky = () => {
        anime({
            targets: '.af-bg-aditional__cloud',
            translateX: 100,
            loop: true,
            easing: 'linear',
            direction: 'alternate',
            duration: 20000,
        })

        anime({
            targets: '.af-bg-aditional__cloud2',
            translateX: -50,
            loop: true,
            easing: 'linear',
            direction: 'alternate',
            duration: 10000,
        })
    }

    React.useEffect(() => {
        animateSky()
    })

    return (
        <main>
            <div className='boxAllies'>
                <Banner
                    backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/contact/contactoDesktop.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/contact/contactoMobile.jpg` }}
                    textBanner={!loading ? title : ''}
                    textDescription={desc}
                    componentsAnimated={elementList}
                />
            </div>

            { openModal && <ModalContact close={setOpenModal} /> }

            <div className="background-contact">
                {/* <FishSec /> */}
                <div id="newFormContact" className="form" data-aos="fade-up" data-aos-duration="1000" data-aos-anchor-placement='top-bottom'>
                    <h2 className="form__title">{title}</h2>
                </div>
            </div>
        </main>
    )
}

const ModalContact = ({ close }) => {
    const lang = window.currentLang
    history.pushState(null, "", lang == 'es' ? '/es/contacto' : '/en/contact');

    anime({
        targets: '.modalContact__wrapper',
        translateY: [200, 0],
        scale: [0.7, 1],
        opacity: [0, 1],
        duration: 700,
        easing: 'easeOutBack',
        delay: 500
    })

    const handleClose = () => {
        anime({
            targets: '.modalContact',
            opacity: [1, 0],
            duration: 700,
            easing: 'easeInQuad',
        })
        anime({
            targets: '.modalContact__wrapper',
            translateY: [0, 200],
            scale: [1, 0.7],
            opacity: [1, 0],
            duration: 700,
            easing: 'easeInBack',
            delay: 0
        })
        setTimeout(() => close(false), 1000)
    }

    return (
        <div className="modalContact">
            <div className="modalContact__wrapper">
                <button className="modalContact__close" onClick={handleClose}>
                    <img className="button__close" src={`/${THEMEURL}/sources/dist/assets/images/general/close-stick.png`} alt="Close" title="Close" />
                </button>
                <div className="modalContact__content">{lang == 'es' ? 'Registro Exitoso' : 'Successful registration'}</div>
                <a href={lang == 'es' ? '/es' : '/en'} className="modalContact__cta">{lang == 'es' ? 'Ir al Inicio' : 'Go to Home'}</a>
                <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 24 150 28" preserveAspectRatio="none">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(57, 189, 229,0.7" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(57, 189, 229,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(57, 189, 229,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#39BDE5" />
                        </g>
                </svg>
            </div>
        </div>
    )
}

export default Loader(Contact)